import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { Star } from '@mui/icons-material';
import { DatasetMenuItem } from '../styling';
import { EmptyStar } from '../style';

function DatasetListItem({ dataset, onDatasetLoadClick, onFavoriteClick }) {
  const { uuid, favorite, name } = dataset;

  const handleDatasetClick = () => {
    onDatasetLoadClick(uuid);
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    onFavoriteClick(uuid);
  };

  const favoriteIcon = (favorite
    ? <Star fontSize="small" color="warning" />
    : <EmptyStar fontSize="small" />
  );

  return (
    <DatasetMenuItem persistOnClick onClick={handleDatasetClick}>
      <IconButton
        size="small"
        onClick={handleFavoriteClick}
        sx={{ padding: '1px 0.2rem 1px 1px' }}
      >
        {favoriteIcon}
      </IconButton>
      <span>{name}</span>
    </DatasetMenuItem>
  );
}

DatasetListItem.propTypes = {
  dataset: PropTypes.object.isRequired,
  onDatasetLoadClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
};

export default DatasetListItem;
